import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft } from "lucide-react";
import { QuestionReviewItem } from "../components/QuestionReviewItem";

/**
 * Session review — per-question detail for a completed or in-progress session.
 * Route: /inceleme/:sessionId
 *
 * Backend hides `correct` / `explanation` / `solution` / `video_url` while
 * status is IN_PROGRESS, so we don't need to guard those on the client side.
 * The row rendering is shared with the result screen via QuestionReviewItem
 * so both entry points show the identical question detail.
 */
export default function SessionReview() {
  const { id } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [openIdx, setOpenIdx] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/sessions/${id}/review`);
        setData(r.data);
      } catch (e) { console.error(e); }
    })();
  }, [id]);

  if (!data) return <div className="text-sm text-slate-500 p-4">Yükleniyor…</div>;

  const items = data.items || [];
  const correct = items.filter((x) => x.result === "CORRECT" || x.is_correct).length;
  const blank = items.filter((x) => x.result === "BLANK").length;

  return (
    <div className="max-w-3xl mx-auto p-4 pb-24 space-y-4">
      <button onClick={() => nav("/")} className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#0F172A]">
        <ArrowLeft size={14}/> Panele Dön
      </button>

      <div className="rounded-2xl border border-[#E2E8F0] bg-white p-5">
        <div className="text-xs uppercase tracking-widest text-slate-400 font-mono mb-1">Çalışma İnceleme</div>
        <div className="font-display text-2xl">
          {data.status === "IN_PROGRESS" ? (
            <span>Devam Ediyor · {items.length} soru</span>
          ) : (
            <span>
              <span className="text-emerald-600">{correct}</span> /{" "}
              <span>{items.length}</span> doğru
              {blank > 0 && <span className="text-slate-500 text-base ml-2">· {blank} boş</span>}
            </span>
          )}
        </div>
      </div>

      <div className="grid gap-2">
        {items.map((it, i) => (
          <QuestionReviewItem
            key={it.question_id}
            item={it}
            index={i}
            open={openIdx === i}
            onToggle={() => setOpenIdx(openIdx === i ? null : i)}
          />
        ))}
      </div>
    </div>
  );
}
